'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var useThrottle = function (_a) {
    var _b = _a.recompute, recompute = _b === void 0 ? false : _b, throttleFunction = _a.throttleFunction, throttleTime = _a.throttleTime;
    var lastUpdatedTime = react.useRef(0);
    var fireAndResetThrottleIfAppropriate = function () {
        if (recompute || (Date.now() - lastUpdatedTime.current) >= throttleTime) {
            lastUpdatedTime.current = Date.now();
            throttleFunction();
        }
    };
    return fireAndResetThrottleIfAppropriate;
};

var useSize = function (throttleTime) {
    if (throttleTime === void 0) { throttleTime = 0; }
    var _a = react.useState({ height: window.innerHeight, width: window.innerWidth }), size = _a[0], setSize = _a[1];
    var throttledWindowSizeHandler = useThrottle({ recompute: false, throttleFunction: function () { return setSize({ height: window.innerHeight, width: window.innerWidth }); }, throttleTime: throttleTime });
    react.useEffect(function () {
        window.addEventListener('resize', throttledWindowSizeHandler);
        return function () {
            window.removeEventListener('resize', throttledWindowSizeHandler);
        };
    }, []);
    return size;
};

exports.useSize = useSize;
